import { render } from "./painting-6.vue?vue&type=template&id=432d3366&scoped=true"
import script from "./painting-6.vue?vue&type=script&lang=js"
export * from "./painting-6.vue?vue&type=script&lang=js"

import "./painting-6.vue?vue&type=style&index=0&id=432d3366&lang=scss&scoped=true"

import exportComponent from "/Users/dima/Projects/OrangeStatic/rise-homestories/public/themes/rise-theme/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-432d3366"]])

export default __exports__